import { AvailableForBooking, OfferedService } from "utils/interfaces"
import { ServicesGroup } from "utils/helpers/ServicesGroup"
import { isServiceHasSlots } from "utils/bookingAvailable"

function isAvailable(service: OfferedService, availableForBooking: AvailableForBooking) {
    return service.available && isServiceHasSlots(service, availableForBooking)
}

export function getOnlineAndOfflineService(
    { services, availableForBooking }: ServicesGroup,
    unCheckSlots?: boolean
) {
    const onlineService = services.find((service) => {
        return unCheckSlots
            ? service.online
            : service.online && isAvailable(service, availableForBooking)
    })
    const offlineService = services.find((service) => {
        return unCheckSlots
            ? !service.online
            : !service.online && isAvailable(service, availableForBooking)
    })
    return {
        onlineService,
        offlineService,
    }
}
